import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { aditionalHeadersModel } from '@kanzi-apes/kanzi-models';

@Injectable({
  providedIn: 'root',
})
export class KanziUtilService {
  constructor() {}

  /**
   * @returns Headers {HttpHeaders} Headers to be used in the http requests.
   *
   * Function to create the Http Headers.
   */
  getHeaders(
    additionalHeaders?: aditionalHeadersModel,
    tokenName?: string,
    tokenPrefix?: string
  ): HttpHeaders {
    const kanziToken = localStorage.getItem(tokenName || 'kanziUserToken');
    if (kanziToken) {
      const token = !tokenName ? JSON.parse(kanziToken).auth_token : kanziToken;
      const prefix = tokenPrefix === 'COGNITO' ? '' : 'Token ';
      let opcions = {
        'Content-Type': 'application/json',
        Authorization: prefix + token,
      };
      if (additionalHeaders) {
        opcions = {
          ...opcions,
          ...additionalHeaders,
        };
      }
      const headers = new HttpHeaders(opcions);
      return headers;
    } else {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });
      return headers;
    }
  }

  /**
   * Builds the HTTP headers used for multipart/form-data uploads.
   * By default it uses the legacy `kanziUserToken` with the `Token` prefix.
   * When `tokenName` is provided, it reads that raw token from storage and
   * applies the given prefix (empty for `COGNITO`), mirroring `getHeaders`.
   * Centralizing token retrieval here avoids direct `localStorage` access from
   * feature services.
   * @param additionalHeaders - (optional) Extra headers to merge into the request
   * @param tokenName - (optional) Storage key of the token to use instead of the default
   * @param tokenPrefix - (optional) Authorization prefix; `COGNITO` results in no prefix
   * @returns The configured HttpHeaders for a file upload request
   */
  getHeadersUploadFile(
    additionalHeaders?: aditionalHeadersModel,
    tokenName?: string,
    tokenPrefix?: string
  ): HttpHeaders {
    const kanziToken = localStorage.getItem(tokenName || 'kanziUserToken');
    if (kanziToken) {
      const token = !tokenName ? JSON.parse(kanziToken).auth_token : kanziToken;
      const prefix = tokenPrefix === 'COGNITO' ? '' : 'Token ';
      let opcions = {
        Authorization: prefix + token,
      };
      if (additionalHeaders) {
        opcions = {
          ...opcions,
          ...additionalHeaders,
        };
      }
      const headers = new HttpHeaders(opcions);
      return headers;
    } else {
      const headers = new HttpHeaders();
      return headers;
    }
  }
}
